module.exports = __webpack_public_path__ + "static/media/sound1.72adda51.mp3";